import { Box, SxProps } from '@mui/material';
import { TBImgType } from '../../../../../utils/mappers/image';
import Img from 'next/image';

type Props = {
  img?: TBImgType;
  sx?: SxProps;
};

const CardImage = ({ img, sx }: Props) => {
  if (!img) return null;
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: 200, md: 300 },
        height: { xs: 200, md: 300 },
        width: '100%',
        borderRadius: 0.5,
        mx: 'auto',
        ...sx,
      }}
    >
      <Img
        src={img.url}
        alt={img.altText}
        width={400}
        height={300}
        style={{
          objectFit: 'cover',
          borderRadius: 'inherit',
          width: '100%',
          height: '100%',
          aspectRatio: 'inherit',
        }}
        placeholder={img.blurDataUrl ? 'blur' : 'empty'}
        blurDataURL={img.blurDataUrl}
      />
    </Box>
  );
};

export default CardImage;
